<div class="pricing-summary-content billing-summary" *ngIf="shouldShowPricingSummary()">
  <span class="title">{{ 'price_breakdown' | translate }}</span>
  <div class="spacing-billing-summary d-flex flex-column">

    <!-- Producto principal -->
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex service-type align-items-center">
        <app-service-icons *ngIf="!isOutOfRange()" [isActiveRouteMap]="true"
          [ServiceProductKey]="summaryData.productInformation.product?.ProductKey!"
          [newServiceIcons]="true"></app-service-icons>
        <img *ngIf="isOutOfRange()" [src]="
            summaryData.productInformation.product?.outOfRangeIcon ||
            '/assets/icons/information-circle.svg'
          " alt="Info icon" class="icon-container" />
        <span *ngIf="showLicensePlateCount">{{ licensePlateCount }}x</span><span> {{
          'PRODUCT_KEY_NAME.' + summaryData.productInformation.product?.ProductKey | translate
          }}</span>
      </div>
      <span class="price">{{ getProductPrice() | number:'1.2-2' }}{{ summaryData.productInformation.ZoneId |
        CurrencyByZoneId }}</span>
    </div>

    <div class="d-flex justify-content-between align-items-center"
      *ngIf="(summaryData.productInformation.product?.ProductKey == ProductKey.PreMOT || summaryData.productInformation.product?.ProductKey == ProductKey.PreMot360) && summaryData.productInformation.product?.addedNonScheduledMotProductKey">
      <div class="d-flex service-type align-items-center">
        <app-service-icons *ngIf="!isOutOfRange()" [isActiveRouteMap]="true"
          [ServiceProductKey]="summaryData.productInformation.product?.addedNonScheduledMotProductKey!"
          [newServiceIcons]="true"></app-service-icons>

        <span *ngIf="showLicensePlateCount">{{ licensePlateCount }}x</span><span> {{
          'PRODUCT_KEY_NAME.' + summaryData.productInformation.product?.addedNonScheduledMotProductKey | translate
          }}</span>


        <span *ngIf="!summaryData.serviceConfiguration?.hasAppointment">{{
          'ITV_APPOINTMENT.1' | translate
          }}</span>
        <span *ngIf="summaryData.serviceConfiguration?.hasAppointment">{{
          'ITV_APPOINTMENT.0' | translate
          }}</span>
      </div>
      <span class="price">{{ summaryData.productInformation.product?.addedNonScheduledMotPrice | number:'1.2-2'
        }}{{ summaryData.productInformation.ZoneId | CurrencyByZoneId }}</span>
    </div>

    <ng-container *ngIf="currentStep === 6 || currentStep === 7 || isTyre()">
      <div *ngFor="let topping of summaryData.toppingInformation" class="d-flex flex-column">
        <div>
          <div class="d-flex service-type justify-content-between">
            <div class="d-flex">
              <img [src]="topping.icon" alt="Topping icon" class="service-icon" />
              <span class="service-name">
                {{
                isRefueling(topping.description ?? '')
                ? summaryData.vehicleInformation.fuelType
                : (topping.title ?? '' | translate)
                }}
              </span>
            </div>
            <span class="price"> {{ topping.price | number:'1.2-2' }}{{ summaryData.productInformation.ZoneId |
              CurrencyByZoneId }}
            </span>
          </div>
        </div>
        <div class="exent-supplement exent-supplement-extra">
          <span *ngIf="isRefueling(topping.title!)">
            {{ 'exentSupplement' | translate }}
          </span>
        </div>
      </div>
    </ng-container>

    <!-- Tasas y cargos adicionales -->

    <ng-container *ngIf="summaryData.productInformation.product?.CaflerFee">
      <div class="d-flex justify-content-between align-items-center">
        <div class="fee-label"><span *ngIf="showLicensePlateCount">{{ licensePlateCount }}x</span>
          <span>{{ getCaflerFeeLabel() }}</span>
        </div>

        <span class="price">{{ (summaryData.productInformation.product?.CaflerFee != null ?
          summaryData.productInformation.product?.CaflerFee! * licensePlateCount : 0) | number:'1.2-2'
          }}{{ summaryData.productInformation.ZoneId | CurrencyByZoneId }}</span>
      </div>
    </ng-container>

    <div class="d-flex justify-content-between align-items-center" *ngIf="summaryData.FixedFee">
      <div class="fee-label">
        <span *ngIf="showLicensePlateCount">{{ licensePlateCount }}x</span>
        <span>{{ 'fixedFee' | translate }}</span>
      </div>

      <span class="price">{{ (summaryData.FixedFee * licensePlateCount) | number:'1.2-2' }}{{
        summaryData.productInformation.ZoneId |
        CurrencyByZoneId
        }}</span>
    </div>

    <div class="d-flex justify-content-between align-items-center" *ngIf="summaryData.urgencyFee">
      <div class="fee-label">
        <span *ngIf="showLicensePlateCount">{{ licensePlateCount }}x</span>
        <span>{{ 'urgency_fee' | translate }}</span>
      </div>

      <span class="price">{{ (summaryData.urgencyFee * licensePlateCount) | number:'1.2-2' }}{{
        summaryData.productInformation.ZoneId |
        CurrencyByZoneId
        }}</span>
    </div>

    <div class="d-flex justify-content-between align-items-center"
      *ngIf="summaryData.refuelingAdditionalFee && summaryData.refuelingAdditionalFee > 0">
      <div class="fee-label">
        <span *ngIf="showLicensePlateCount">{{ licensePlateCount }}x</span>
        <span>{{ 'refuelingAdditionalFee' | translate }}</span>
        <img src="/assets/icons/information-circle.svg" alt="Info icon" class="icon-size-small align-bottom"
          data-bs-toggle="modal" data-bs-target="#tasaRepostajeModal" />
      </div>

      <span class="price">{{ (summaryData.refuelingAdditionalFee * licensePlateCount) | number:'1.2-2' }}{{
        summaryData.productInformation.ZoneId |
        CurrencyByZoneId }}</span>
    </div>

    <!-- IVA -->
    <div class="d-flex justify-content-between align-items-center" *ngIf="summaryData.TotalOrderTaxAmount">
      <span>{{ 'vat' | translate }} ({{ summaryData.OrderTax }}%)</span>
      <span class="price">{{ summaryData.TotalOrderTaxAmount | number:'1.2-2' }}{{
        summaryData.productInformation.ZoneId |
        CurrencyByZoneId }}</span>
    </div>

    <!-- Total -->
    <div class="d-flex justify-content-between billing-summary title" *ngIf="isFunnelDialog || isTransit()">
      <span>{{ 'total' | translate }}</span>
      <span>{{ summaryData.TotalOrderAmount | number:'1.2-2' }}{{ summaryData.productInformation.ZoneId |
        CurrencyByZoneId }}</span>
    </div>

    <!-- Código promocional -->
    <ng-container *ngIf="!summaryData.productInformation.product?.outOfRange"><ng-container
        *ngIf="promotionCode && !promotionCodeValidator">
        <div class="d-flex justify-content-between align-items-center">
          <span class="promotion-code-text">{{ promotionCode }}</span>
          <span class="price">-{{ promotionCodeValue | number:'1.2-2' }} {{ ZoneId | CurrencyByZoneId }}</span>
        </div>
      </ng-container></ng-container>
  </div>
</div>